import { FormControl, FormGroup } from "@angular/forms";

export function markAllAsDirtyAndTouched(form: FormGroup)
{
    if (!form)
        return;

    Object.keys(form.controls).forEach(key =>
    {
        const control = form.controls[key];

        if (control instanceof FormControl)
        {
            control.markAsDirty();
            control.markAsTouched();
        }

        if (control instanceof FormGroup)
        {
            Object.keys(control.controls).forEach(key =>
            {
                control.controls[key].markAsDirty();
                control.controls[key].markAsTouched();
            })
        }
    });
}